module.exports = __webpack_public_path__ + "static/media/appleIconDark.ee1a0b72.svg";